(function () {
  "use strict";

  var LEGACY_KEY = "theartfolio_favourites";
  var COLLECTIONS_KEY = "theartfolio_collections";
  var ACTIVE_BOARD_KEY = "theartfolio_collections_active";
  var ANON_KEY = "theartfolio_taste_anon";
  var MAX_BOARDS = 24;
  var MAX_ITEMS_TOTAL = 120;
  var MAX_COMPARE = 6;
  var DISCOVER_PATH = "/pages/discover";
  var FAVOURITES_BOARD_ID = "board-favourites";
  var storageUsable = false;
  var compareIds = {};
  var activeBoardId = FAVOURITES_BOARD_ID;
  var pickerLook = null;
  var syncTimer = null;
  var syncState = "local"; // local | syncing | synced | error | offline

  // Device-local by default. Optional Cloudflare collector enables sync + share (Phase 2).

  function collectorBase() {
    var endpoint = window.theme && window.theme.tasteEndpoint;
    if (!endpoint) return "";
    return String(endpoint).replace(/\/v1\/events\/?$/i, "").replace(/\/$/, "");
  }

  function customerId() {
    var id = window.theme && window.theme.customerId;
    if (id == null || id === "") return "";
    return String(id);
  }

  function anonId() {
    if (window.TheArtfolioTaste && typeof window.TheArtfolioTaste.anonId === "function") {
      try {
        var fromTaste = window.TheArtfolioTaste.anonId();
        if (fromTaste) return fromTaste;
      } catch (error) {}
    }
    if (!storageUsable) return "";
    try {
      var existing = window.localStorage.getItem(ANON_KEY) || "";
      if (existing) return existing;
      var id = "anon-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 10);
      window.localStorage.setItem(ANON_KEY, id);
      return id;
    } catch (error) {
      return "";
    }
  }

  function sharedCollectionPath() {
    return (window.theme && window.theme.sharedCollectionPath) || "/pages/shared-collection";
  }

  function testStorage() {
    try {
      var probe = COLLECTIONS_KEY + "_probe";
      window.localStorage.setItem(probe, "1");
      window.localStorage.removeItem(probe);
      return true;
    } catch (error) {
      return false;
    }
  }

  function makeId(prefix) {
    return prefix + "-" + Date.now() + "-" + Math.random().toString(36).slice(2, 8);
  }

  function nowIso() {
    return new Date().toISOString();
  }

  function normaliseUrl(url) {
    try {
      var parsed = new URL(url, window.location.origin);
      if (parsed.protocol !== "http:" && parsed.protocol !== "https:") return "";
      parsed.hash = "";
      return parsed.href;
    } catch (error) {
      return "";
    }
  }

  function productKeyFromUrl(url) {
    try {
      var parsed = new URL(url, window.location.origin);
      var parts = parsed.pathname.split("/").filter(Boolean);
      var index = -1;
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].toLowerCase() === "products") {
          index = i;
          break;
        }
      }
      if (index > -1 && parts[index + 1]) {
        return decodeURIComponent(parts[index + 1]).toLowerCase();
      }
      return parsed.pathname.replace(/\/+$/, "").toLowerCase();
    } catch (error) {
      return "";
    }
  }

  function favouriteProductKey(item) {
    if (item && item.handle) return String(item.handle).toLowerCase();
    if (item && item.productKey) return String(item.productKey).toLowerCase();
    return productKeyFromUrl(item && item.url);
  }

  function optionsFromUrl(url) {
    try {
      var params = new URL(url, window.location.origin).searchParams;
      function param() {
        for (var i = 0; i < arguments.length; i++) {
          var value = params.get(arguments[i]);
          if (value != null && String(value).trim()) return String(value).trim();
        }
        return "";
      }
      return {
        frameStyle: param("frame") || "Classic",
        colour: param("colour", "color") || "Oak",
        size: param("size") || "Medium",
        mount: param("mount") || "Mounted",
        mountColour: param("mountcolour", "mount_colour", "mount-colour") || "Fresh Linen",
        scene: param("scene") || "artwork"
      };
    } catch (error) {
      return {
        frameStyle: "Classic",
        colour: "Oak",
        size: "Medium",
        mount: "Mounted",
        mountColour: "Fresh Linen",
        scene: "artwork"
      };
    }
  }

  function normaliseOptions(options) {
    options = options || {};
    return {
      frameStyle: options.frameStyle || options.frame || "Classic",
      colour: options.colour || options.color || "Oak",
      size: options.size || "Medium",
      mount: options.mount || "Mounted",
      mountColour: options.mountColour || options.mountcolour || "Fresh Linen",
      scene: options.scene || "artwork"
    };
  }

  function sceneLabel(scene) {
    var text = String(scene || "artwork").replace(/[-_]+/g, " ");
    return text.replace(/\b\w/g, function (letter) { return letter.toUpperCase(); });
  }

  function optionsSummary(options) {
    options = normaliseOptions(options);
    var parts = [
      options.frameStyle,
      options.colour,
      options.size,
      options.mount
    ];
    if (options.mount && !/no mount|none|unmounted/i.test(options.mount) && options.mountColour) {
      parts.push(options.mountColour);
    }
    parts.push(sceneLabel(options.scene));
    return parts.join(" · ");
  }

  function configuredUrl(baseUrl, options) {
    var url = new URL(baseUrl, window.location.origin);
    options = normaliseOptions(options);
    [
      ["frame", options.frameStyle],
      ["colour", options.colour],
      ["size", options.size],
      ["mount", options.mount],
      ["mountcolour", options.mountColour],
      ["scene", options.scene]
    ].forEach(function (entry) {
      if (entry[1] != null && String(entry[1]).trim()) {
        url.searchParams.set(entry[0], String(entry[1]));
      }
    });
    return url.href;
  }

  function lookSignature(item) {
    if (!item) return "";
    var options = normaliseOptions(item.options || optionsFromUrl(item.url));
    return favouriteProductKey(item) + "|" + optionsSummary(options);
  }

  function discoverRemixUrl(favourite) {
    var handle = favouriteProductKey(favourite);
    if (!handle) return DISCOVER_PATH;
    var url = new URL(DISCOVER_PATH, window.location.origin);
    var options = normaliseOptions(favourite.options || optionsFromUrl(favourite.url));
    url.searchParams.set("product", handle);
    if (favourite.id) url.searchParams.set("look", favourite.id);
    [
      ["frame", options.frameStyle],
      ["colour", options.colour],
      ["size", options.size],
      ["mount", options.mount],
      ["mountcolour", options.mountColour],
      ["scene", options.scene]
    ].forEach(function (entry) {
      if (entry[1]) url.searchParams.set(entry[0], entry[1]);
    });
    if (favourite.orientation) url.searchParams.set("do", favourite.orientation);
    if (favourite.genre) url.searchParams.set("dcat", favourite.genre);
    if (favourite.colours && favourite.colours[0]) url.searchParams.set("dc", favourite.colours[0]);
    return url.pathname + url.search;
  }

  function enrichFavourite(item) {
    if (!item) return null;
    var url = normaliseUrl(item.url);
    if (!url) return null;
    var productKey = favouriteProductKey(item) || productKeyFromUrl(url);
    if (!productKey) return null;
    var options = normaliseOptions(item.options || optionsFromUrl(url));
    var id = item.id || makeId("look");
    return Object.assign({}, item, {
      id: id,
      url: configuredUrl(url.split("?")[0], options),
      productKey: productKey,
      handle: productKey,
      options: options,
      summary: optionsSummary(options),
      orientation: item.orientation || "",
      genre: item.genre || "",
      colours: Array.isArray(item.colours) ? item.colours : [],
      moods: Array.isArray(item.moods) ? item.moods : (item.moods ? String(item.moods).split(/\s+/) : [])
    });
  }

  function emptyStore() {
    var stamp = nowIso();
    return {
      version: 1,
      boards: [{
        id: FAVOURITES_BOARD_ID,
        name: "Favourites",
        kind: "favourites",
        createdAt: stamp,
        updatedAt: stamp,
        itemIds: []
      }],
      items: {}
    };
  }

  function migrateLegacyArray(legacy) {
    var store = emptyStore();
    var fav = store.boards[0];
    var seenSig = {};
    (Array.isArray(legacy) ? legacy : []).forEach(function (raw) {
      var item = enrichFavourite(raw);
      if (!item) return;
      var sig = lookSignature(item);
      if (seenSig[sig]) return;
      seenSig[sig] = true;
      store.items[item.id] = item;
      fav.itemIds.push(item.id);
    });
    fav.updatedAt = nowIso();
    return store;
  }

  function pruneStore(store) {
    var next = {
      version: 1,
      boards: [],
      items: {}
    };
    var used = {};
    var favBoard = null;
    (store.boards || []).forEach(function (board) {
      if (!board || !board.id) return;
      var ids = [];
      (board.itemIds || []).forEach(function (id) {
        var item = enrichFavourite(store.items && store.items[id]);
        if (!item) return;
        next.items[item.id] = item;
        used[item.id] = true;
        if (ids.indexOf(item.id) === -1) ids.push(item.id);
      });
      var copy = {
        id: board.id,
        name: String(board.name || "Collection").trim() || "Collection",
        kind: board.kind === "favourites" ? "favourites" : "project",
        createdAt: board.createdAt || nowIso(),
        updatedAt: board.updatedAt || nowIso(),
        itemIds: ids
      };
      if (copy.kind === "favourites") favBoard = copy;
      else next.boards.push(copy);
    });
    if (!favBoard) {
      favBoard = emptyStore().boards[0];
    }
    next.boards = [favBoard].concat(next.boards).slice(0, MAX_BOARDS);

    var allIds = Object.keys(next.items);
    if (allIds.length > MAX_ITEMS_TOTAL) {
      var keep = {};
      next.boards.forEach(function (board) {
        board.itemIds.forEach(function (id) {
          if (Object.keys(keep).length < MAX_ITEMS_TOTAL) keep[id] = true;
        });
      });
      Object.keys(next.items).forEach(function (id) {
        if (!keep[id]) delete next.items[id];
      });
      next.boards.forEach(function (board) {
        board.itemIds = board.itemIds.filter(function (id) { return !!next.items[id]; });
      });
    }
    return next;
  }

  function readStore() {
    if (!storageUsable) return emptyStore();
    try {
      var raw = window.localStorage.getItem(COLLECTIONS_KEY);
      if (raw) {
        var parsed = JSON.parse(raw);
        if (parsed && parsed.version === 1 && Array.isArray(parsed.boards)) {
          return pruneStore(parsed);
        }
      }
      var legacy = JSON.parse(window.localStorage.getItem(LEGACY_KEY) || "[]");
      return pruneStore(migrateLegacyArray(legacy));
    } catch (error) {
      return emptyStore();
    }
  }

  function writeStore(store) {
    if (!storageUsable) return false;
    try {
      var next = pruneStore(store);
      next.syncedAt = Date.now();
      window.localStorage.setItem(COLLECTIONS_KEY, JSON.stringify(next));
      // Keep a legacy mirror of the Favourites board for any older readers.
      var favItems = getBoardItems(next, getFavouritesBoard(next).id);
      window.localStorage.setItem(LEGACY_KEY, JSON.stringify(favItems.slice(0, 50)));
      document.dispatchEvent(new CustomEvent("theartfolio:favouriteschange"));
      scheduleCollectionsPush();
      return true;
    } catch (error) {
      return false;
    }
  }

  function mergeStores(a, b) {
    if (!a) return b;
    if (!b) return a;
    var boardsById = {};
    var items = {};

    function ingest(store) {
      Object.keys(store.items || {}).forEach(function (id) {
        var item = enrichFavourite(store.items[id]);
        if (!item) return;
        var prev = items[id];
        var prevTs = Date.parse(prev && prev.savedAt ? prev.savedAt : "") || 0;
        var nextTs = Date.parse(item.savedAt || "") || 0;
        if (!prev || nextTs >= prevTs) items[id] = item;
      });
      (store.boards || []).forEach(function (board) {
        if (!board || !board.id) return;
        var prev = boardsById[board.id];
        var prevTs = Date.parse(prev && prev.updatedAt ? prev.updatedAt : "") || 0;
        var nextTs = Date.parse(board.updatedAt || "") || 0;
        if (!prev || nextTs >= prevTs || (board.kind === "favourites" && (!prev || prev.kind !== "favourites"))) {
          boardsById[board.id] = {
            id: board.id,
            name: board.name,
            kind: board.kind === "favourites" ? "favourites" : "project",
            createdAt: board.createdAt || nowIso(),
            updatedAt: board.updatedAt || nowIso(),
            itemIds: Array.isArray(board.itemIds) ? board.itemIds.slice() : []
          };
        }
      });
    }

    ingest(a);
    ingest(b);

    var boards = Object.keys(boardsById).map(function (id) {
      var board = boardsById[id];
      board.itemIds = (board.itemIds || []).filter(function (itemId) { return !!items[itemId]; });
      return board;
    });
    boards.sort(function (left, right) {
      if (left.kind === "favourites") return -1;
      if (right.kind === "favourites") return 1;
      return String(left.name || "").localeCompare(String(right.name || ""));
    });

    return pruneStore({
      version: 1,
      boards: boards,
      items: items,
      syncedAt: Date.now()
    });
  }

  function setSyncState(state) {
    syncState = state;
    document.dispatchEvent(new CustomEvent("theartfolio:collectionssync", { detail: { state: state } }));
  }

  function scheduleCollectionsPush() {
    if (!collectorBase()) {
      setSyncState("local");
      return;
    }
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(function () {
      pushCollectionsStore();
    }, 1200);
  }

  function pushCollectionsStore() {
    var base = collectorBase();
    var id = anonId();
    if (!base || !id || !storageUsable) return Promise.resolve(false);
    setSyncState("syncing");
    var body = {
      anonId: id,
      store: readStore()
    };
    var cid = customerId();
    if (cid) body.customerId = cid;
    return fetch(base + "/v1/collections", {
      method: "PUT",
      credentials: "omit",
      headers: { "content-type": "application/json", accept: "application/json" },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        if (!res.ok) throw new Error("push_failed");
        setSyncState("synced");
        return true;
      })
      .catch(function () {
        setSyncState("error");
        return false;
      });
  }

  function pullCollectionsStore() {
    var base = collectorBase();
    var id = anonId();
    if (!base || !id || !storageUsable) return Promise.resolve(false);
    setSyncState("syncing");
    var url = base + "/v1/collections?anonId=" + encodeURIComponent(id);
    var cid = customerId();
    if (cid) url += "&customerId=" + encodeURIComponent(cid);
    return fetch(url, {
      method: "GET",
      credentials: "omit",
      headers: { accept: "application/json" }
    })
      .then(function (res) {
        if (!res.ok) throw new Error("pull_failed");
        return res.json();
      })
      .then(function (data) {
        if (!data || !data.ok) throw new Error("pull_failed");
        if (!data.store) {
          setSyncState("synced");
          return pushCollectionsStore();
        }
        var merged = mergeStores(readStore(), data.store);
        window.localStorage.setItem(COLLECTIONS_KEY, JSON.stringify(merged));
        var favItems = getBoardItems(merged, getFavouritesBoard(merged).id);
        window.localStorage.setItem(LEGACY_KEY, JSON.stringify(favItems.slice(0, 50)));
        document.dispatchEvent(new CustomEvent("theartfolio:favouriteschange"));
        setSyncState("synced");
        return pushCollectionsStore();
      })
      .catch(function () {
        setSyncState(collectorBase() ? "error" : "local");
        return false;
      });
  }

  function createBoardShare(boardId) {
    var base = collectorBase();
    var id = anonId();
    if (!base || !id) {
      return Promise.reject(new Error("sync_unavailable"));
    }
    var store = readStore();
    var board = findBoard(store, boardId);
    if (!board) return Promise.reject(new Error("missing_board"));
    var items = getBoardItems(store, boardId);
    if (!items.length) return Promise.reject(new Error("empty_board"));
    return fetch(base + "/v1/collections/share", {
      method: "POST",
      credentials: "omit",
      headers: { "content-type": "application/json", accept: "application/json" },
      body: JSON.stringify({
        anonId: id,
        title: board.name,
        board: board,
        items: items
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error("share_failed");
        return res.json();
      })
      .then(function (data) {
        if (!data || !data.ok || !data.token) throw new Error("share_failed");
        var path = sharedCollectionPath();
        var shareUrl = new URL(path, window.location.origin);
        shareUrl.searchParams.set("token", data.token);
        return shareUrl.href;
      });
  }

  function getFavouritesBoard(store) {
    store = store || readStore();
    for (var i = 0; i < store.boards.length; i++) {
      if (store.boards[i].kind === "favourites") return store.boards[i];
    }
    return store.boards[0];
  }

  function findBoard(store, boardId) {
    for (var i = 0; i < store.boards.length; i++) {
      if (store.boards[i].id === boardId) return store.boards[i];
    }
    return null;
  }

  function getBoardItems(store, boardId) {
    var board = findBoard(store, boardId);
    if (!board) return [];
    var items = [];
    (board.itemIds || []).forEach(function (id) {
      var item = enrichFavourite(store.items[id]);
      if (item) items.push(item);
    });
    return items;
  }

  function getFavourites() {
    var store = readStore();
    return getBoardItems(store, getFavouritesBoard(store).id);
  }

  function getBoards() {
    return readStore().boards.slice();
  }

  function getActiveBoardId() {
    if (!storageUsable) return FAVOURITES_BOARD_ID;
    try {
      var saved = window.localStorage.getItem(ACTIVE_BOARD_KEY);
      if (saved && findBoard(readStore(), saved)) return saved;
    } catch (error) {}
    return getFavouritesBoard().id;
  }

  function setActiveBoardId(boardId) {
    activeBoardId = boardId || FAVOURITES_BOARD_ID;
    if (!storageUsable) return;
    try {
      window.localStorage.setItem(ACTIVE_BOARD_KEY, activeBoardId);
    } catch (error) {}
  }

  function trackFavourite(item) {
    if (!window.TheArtfolioTaste || typeof window.TheArtfolioTaste.track !== "function") return;
    try {
      window.TheArtfolioTaste.track("favourite", {
        handle: item.productKey || item.handle,
        options: item.options,
        moods: item.moods,
        colours: item.colours,
        genre: item.genre,
        orientation: item.orientation
      });
    } catch (error) {}
  }

  function addItemToBoard(boardId, favourite) {
    var enriched = enrichFavourite(favourite);
    if (!enriched) return false;
    var store = readStore();
    var board = findBoard(store, boardId);
    if (!board) return false;

    var existingId = null;
    (board.itemIds || []).forEach(function (id) {
      var existing = store.items[id];
      if (existing && lookSignature(existing) === lookSignature(enriched)) existingId = id;
    });

    if (existingId) {
      enriched.id = existingId;
      enriched.savedAt = nowIso();
      store.items[existingId] = enriched;
    } else {
      if (Object.keys(store.items).length >= MAX_ITEMS_TOTAL) return false;
      enriched.savedAt = enriched.savedAt || nowIso();
      store.items[enriched.id] = enriched;
      board.itemIds = [enriched.id].concat(board.itemIds || []);
    }
    board.updatedAt = nowIso();
    var saved = writeStore(store);
    if (saved && board.kind === "favourites") trackFavourite(enriched);
    return saved;
  }

  function addFavourite(favourite) {
    return addItemToBoard(getFavouritesBoard().id, favourite);
  }

  function removeItemFromBoard(boardId, itemId) {
    var store = readStore();
    var board = findBoard(store, boardId);
    if (!board) return false;
    var before = board.itemIds.length;
    board.itemIds = (board.itemIds || []).filter(function (id) { return id !== itemId; });
    if (board.itemIds.length === before) return true;
    board.updatedAt = nowIso();

    var stillUsed = false;
    store.boards.forEach(function (other) {
      if ((other.itemIds || []).indexOf(itemId) > -1) stillUsed = true;
    });
    if (!stillUsed) delete store.items[itemId];

    Object.keys(compareIds).forEach(function (compareId) {
      if (!store.items[compareId]) delete compareIds[compareId];
    });
    return writeStore(store);
  }

  function removeFavourite(id) {
    return removeItemFromBoard(getFavouritesBoard().id, id);
  }

  function isFavourite(url) {
    var probe = enrichFavourite({ url: url, options: optionsFromUrl(url) });
    if (!probe) return false;
    var sig = lookSignature(probe);
    return getFavourites().some(function (item) {
      return lookSignature(item) === sig;
    });
  }

  function findFavouriteForUrl(url) {
    var probe = enrichFavourite({ url: url, options: optionsFromUrl(url) });
    if (!probe) return null;
    var sig = lookSignature(probe);
    return getFavourites().find(function (item) {
      return lookSignature(item) === sig;
    }) || null;
  }

  function createBoard(name) {
    var store = readStore();
    if (store.boards.length >= MAX_BOARDS) return null;
    var stamp = nowIso();
    var board = {
      id: makeId("board"),
      name: String(name || "").trim() || "Untitled collection",
      kind: "project",
      createdAt: stamp,
      updatedAt: stamp,
      itemIds: []
    };
    store.boards.push(board);
    if (!writeStore(store)) return null;
    return board;
  }

  function renameBoard(boardId, name) {
    var store = readStore();
    var board = findBoard(store, boardId);
    if (!board || board.kind === "favourites") return false;
    board.name = String(name || "").trim() || board.name;
    board.updatedAt = nowIso();
    return writeStore(store);
  }

  function deleteBoard(boardId) {
    var store = readStore();
    var board = findBoard(store, boardId);
    if (!board || board.kind === "favourites") return false;
    store.boards = store.boards.filter(function (entry) { return entry.id !== boardId; });
    var used = {};
    store.boards.forEach(function (entry) {
      (entry.itemIds || []).forEach(function (id) { used[id] = true; });
    });
    Object.keys(store.items).forEach(function (id) {
      if (!used[id]) delete store.items[id];
    });
    if (activeBoardId === boardId) setActiveBoardId(getFavouritesBoard(store).id);
    return writeStore(store);
  }

  function moveItemToBoard(itemId, fromBoardId, toBoardId) {
    if (fromBoardId === toBoardId) return true;
    var store = readStore();
    var from = findBoard(store, fromBoardId);
    var to = findBoard(store, toBoardId);
    var item = store.items[itemId];
    if (!from || !to || !item) return false;
    from.itemIds = (from.itemIds || []).filter(function (id) { return id !== itemId; });
    if ((to.itemIds || []).indexOf(itemId) === -1) {
      to.itemIds = [itemId].concat(to.itemIds || []);
    }
    from.updatedAt = nowIso();
    to.updatedAt = nowIso();
    return writeStore(store);
  }

  function copyItemToBoard(itemId, toBoardId) {
    var store = readStore();
    var item = enrichFavourite(store.items[itemId]);
    var to = findBoard(store, toBoardId);
    if (!item || !to) return false;
    return addItemToBoard(toBoardId, Object.assign({}, item, { id: makeId("look") }));
  }

  function seedFromProduct(product) {
    if (!product) return {};
    return {
      handle: product.handle || "",
      orientation: product.orientation || "",
      genre: product.genre || "",
      colours: Array.isArray(product.colours) ? product.colours.slice() : [],
      moods: Array.isArray(product.moods)
        ? product.moods.slice()
        : (product.moods ? String(product.moods).split(/\s+/).filter(Boolean) : [])
    };
  }

  function currentLook(button) {
    var discover = button.closest("[data-discover]");
    if (discover && discover.discoveryState) {
      var product = discover.discoveryState.getProduct();
      if (!product || !product.handle) return null;
      var discoverOptions = normaliseOptions(discover.discoveryState.getOptions());
      return Object.assign({
        url: configuredUrl(
          product.url || ("/products/" + encodeURIComponent(product.handle)),
          discoverOptions
        ),
        image: product.image || product.imageHighRes || "",
        title: product.title || "Untitled artwork",
        summary: optionsSummary(discoverOptions),
        options: discoverOptions,
        productKey: String(product.handle).toLowerCase(),
        handle: String(product.handle).toLowerCase()
      }, seedFromProduct(product));
    }

    var visualiser = button.closest("[data-frame-visualiser]");
    var api = visualiser && visualiser.frameVisualiser;
    if (!api || !api.getConfiguredUrl || !api.getOptions) return null;
    var options = normaliseOptions(api.getOptions());
    var image = visualiser.querySelector(".piece img");
    var productRoot = visualiser.closest("[data-product]");
    var title = productRoot && productRoot.querySelector("h1");
    var seedRoot = productRoot || visualiser.closest("[data-look-seed]");
    var seed = {
      handle: seedRoot && seedRoot.getAttribute("data-product-handle") || "",
      orientation: seedRoot && seedRoot.getAttribute("data-orientation") || "",
      genre: seedRoot && seedRoot.getAttribute("data-genre") || "",
      colours: seedRoot && seedRoot.getAttribute("data-colours")
        ? seedRoot.getAttribute("data-colours").split(",").map(function (part) { return part.trim(); }).filter(Boolean)
        : [],
      moods: seedRoot && seedRoot.getAttribute("data-moods")
        ? seedRoot.getAttribute("data-moods").split(/\s+/).filter(Boolean)
        : []
    };
    return Object.assign({
      url: api.getConfiguredUrl(),
      image: image ? (image.currentSrc || image.src) : "",
      title: title ? title.textContent.trim() : (image && image.alt) || "Untitled artwork",
      summary: optionsSummary(options),
      options: options,
      productKey: productKeyFromUrl(api.getConfiguredUrl()) || seed.handle,
      handle: productKeyFromUrl(api.getConfiguredUrl()) || seed.handle
    }, seed);
  }

  window.TheArtfolioFavourites = {
    getFavourites: getFavourites,
    addFavourite: addFavourite,
    removeFavourite: removeFavourite,
    isFavourite: isFavourite,
    findFavouriteForUrl: findFavouriteForUrl,
    getBoards: getBoards,
    getBoardItems: function (boardId) { return getBoardItems(readStore(), boardId); },
    createBoard: createBoard,
    renameBoard: renameBoard,
    deleteBoard: deleteBoard,
    addItemToBoard: addItemToBoard,
    removeItemFromBoard: removeItemFromBoard,
    moveItemToBoard: moveItemToBoard,
    copyItemToBoard: copyItemToBoard,
    getActiveBoardId: getActiveBoardId,
    setActiveBoardId: setActiveBoardId,
    pullCollectionsStore: pullCollectionsStore,
    pushCollectionsStore: pushCollectionsStore,
    createBoardShare: createBoardShare,
    collectorBase: collectorBase,
    productKeyFromUrl: productKeyFromUrl,
    optionsFromUrl: optionsFromUrl,
    normaliseOptions: normaliseOptions,
    optionsSummary: optionsSummary,
    configuredUrl: configuredUrl,
    discoverRemixUrl: discoverRemixUrl,
    enrichFavourite: enrichFavourite,
    lookSignature: lookSignature
  };

  function measureShopifyAdminChrome() {
    var candidates = [
      document.getElementById("PBarNextFrameWrapper"),
      document.getElementById("admin-bar-iframe"),
      document.getElementById("PreviewBarContainer"),
      document.querySelector('[id*="admin-bar"], [class*="preview-bar"], [class*="admin-bar"], [class*="pbar"]')
    ];
    var height = 0;
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (!el) continue;
      if (el.id === "PBarNextFrame") continue;
      var box = el.getBoundingClientRect();
      if (box.height > 0 && box.height < 140 && box.bottom >= (window.innerHeight - 4)) {
        height = Math.max(height, Math.ceil(box.height));
      }
    }
    if (!height && document.documentElement.classList.contains("shopify-design-mode")) {
      height = 56;
    }
    if (height) height += 4;
    document.documentElement.style.setProperty("--shopify-admin-chrome", height ? height + "px" : "0px");
    document.documentElement.classList.toggle(
      "has-shopify-admin-chrome",
      height > 0 || document.documentElement.classList.contains("shopify-design-mode")
    );
    return height;
  }

  document.addEventListener("DOMContentLoaded", function () {
    measureShopifyAdminChrome();
    window.addEventListener("resize", measureShopifyAdminChrome);
    if (typeof MutationObserver === "function") {
      var chromeTimer = null;
      var observer = new MutationObserver(function () {
        window.clearTimeout(chromeTimer);
        chromeTimer = window.setTimeout(measureShopifyAdminChrome, 50);
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
    storageUsable = testStorage();
    if (!storageUsable) {
      document.documentElement.classList.add("favourites-unavailable");
      return;
    }

    // Migrate legacy favourites into collections store once.
    writeStore(readStore());
    activeBoardId = getActiveBoardId();

    var shelf = document.querySelector("[data-favourites-shelf]");
    var backdrop = document.querySelector("[data-favourites-backdrop]");
    var closeButton = document.querySelector("[data-favourites-close]");
    var carousel = document.querySelector("[data-favourites-carousel]");
    var empty = document.querySelector("[data-favourites-empty]");
    var boardTabs = document.querySelector("[data-collections-boards]");
    var boardTitle = document.querySelector("[data-collections-board-title]");
    var boardActions = document.querySelector("[data-collections-board-actions]");
    var newBoardBtn = document.querySelector("[data-collections-new]");
    var renameBoardBtn = document.querySelector("[data-collections-rename]");
    var deleteBoardBtn = document.querySelector("[data-collections-delete]");
    var shareBoardBtn = document.querySelector("[data-collections-share]");
    var syncLabel = document.querySelector("[data-collections-sync-label]");
    var compareBar = document.querySelector("[data-favourites-compare-bar]");
    var compareCount = document.querySelector("[data-favourites-compare-count]");
    var compareOpen = document.querySelector("[data-favourites-compare-open]");
    var compareClear = document.querySelector("[data-favourites-compare-clear]");
    var comparePanel = document.querySelector("[data-favourites-compare]");
    var compareGrid = document.querySelector("[data-favourites-compare-grid]");
    var compareClose = document.querySelector("[data-favourites-compare-close]");
    var picker = document.querySelector("[data-collections-picker]");
    var pickerList = document.querySelector("[data-collections-picker-list]");
    var pickerNew = document.querySelector("[data-collections-picker-new]");
    var pickerClose = document.querySelector("[data-collections-picker-close]");
    var openButtons = document.querySelectorAll("[data-favourites-open]");
    var countEls = document.querySelectorAll("[data-favourites-count]");
    var countStatus = document.querySelector("[data-favourites-count-status]");
    var toast = document.querySelector("[data-favourites-toast]");
    var lastOpener = null;
    var toastTimer = null;
    var closeTimer = null;

    if (!shelf || !backdrop || !closeButton || !carousel || !empty) return;

    function showToast(message) {
      if (!toast) return;
      window.clearTimeout(toastTimer);
      toast.textContent = message;
      toast.classList.add("is-visible");
      toastTimer = window.setTimeout(function () {
        toast.classList.remove("is-visible");
      }, 2200);
    }

    function totalSavedCount() {
      return Object.keys(readStore().items).length;
    }

    function renderCount() {
      var count = totalSavedCount();
      countEls.forEach(function (element) { element.textContent = String(count); });
      if (countStatus) {
        countStatus.textContent = count + (count === 1 ? " saved look" : " saved looks");
      }
    }

    function safeImageUrl(value) {
      try {
        var parsed = new URL(value, window.location.origin);
        return parsed.protocol === "http:" || parsed.protocol === "https:" ? parsed.href : "";
      } catch (error) {
        return "";
      }
    }

    function activeItems() {
      return getBoardItems(readStore(), activeBoardId);
    }

    function selectedCompare() {
      return activeItems().filter(function (item) { return !!compareIds[item.id]; });
    }

    function updateCompareBar() {
      var selected = selectedCompare();
      if (compareBar) compareBar.hidden = selected.length < 1;
      if (compareCount) compareCount.textContent = selected.length + " selected";
      if (compareOpen) {
        compareOpen.disabled = selected.length < 2;
        compareOpen.textContent = selected.length < 2
          ? "Select 2–" + MAX_COMPARE + " to compare"
          : "Compare " + selected.length;
      }
    }

    function setCompareOpen(open) {
      if (!comparePanel || !compareGrid) return;
      if (!open) {
        comparePanel.hidden = true;
        comparePanel.setAttribute("aria-hidden", "true");
        return;
      }
      var selected = selectedCompare().slice(0, MAX_COMPARE);
      compareGrid.textContent = "";
      selected.forEach(function (favourite) {
        var column = document.createElement("article");
        column.className = "favourite-compare-card";

        var imageUrl = safeImageUrl(favourite.image);
        if (imageUrl) {
          var image = document.createElement("img");
          image.src = imageUrl;
          image.alt = "";
          image.loading = "lazy";
          column.appendChild(image);
        }

        var title = document.createElement("strong");
        title.className = "favourite-compare-title";
        title.textContent = favourite.title || "Untitled artwork";
        column.appendChild(title);

        var summary = document.createElement("p");
        summary.className = "favourite-compare-summary";
        summary.textContent = favourite.summary || optionsSummary(favourite.options);
        column.appendChild(summary);

        var actions = document.createElement("div");
        actions.className = "favourite-compare-actions";

        var openLink = document.createElement("a");
        openLink.className = "favourite-card-action favourite-card-action--primary";
        openLink.href = normaliseUrl(favourite.url);
        openLink.textContent = "Buy as shown";
        actions.appendChild(openLink);

        var remix = document.createElement("a");
        remix.className = "favourite-card-action";
        remix.href = discoverRemixUrl(favourite);
        remix.textContent = "Remix";
        actions.appendChild(remix);

        var remove = document.createElement("button");
        remove.type = "button";
        remove.className = "favourite-card-action";
        remove.textContent = "Deselect";
        remove.addEventListener("click", function () {
          delete compareIds[favourite.id];
          setCompareOpen(true);
          renderShelf();
        });
        actions.appendChild(remove);

        column.appendChild(actions);
        compareGrid.appendChild(column);
      });

      comparePanel.hidden = false;
      comparePanel.setAttribute("aria-hidden", "false");
    }

    function setPickerOpen(open, look) {
      if (!picker || !pickerList) return;
      pickerLook = open ? look : null;
      picker.hidden = !open;
      picker.setAttribute("aria-hidden", open ? "false" : "true");
      if (!open) return;
      pickerList.textContent = "";
      getBoards().forEach(function (board) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "collections-picker-item";
        btn.textContent = board.name + (board.kind === "favourites" ? " (default)" : "");
        btn.addEventListener("click", function () {
          if (!pickerLook) return;
          var payload = Object.assign({}, pickerLook, {
            id: makeId("look"),
            savedAt: nowIso()
          });
          if (!addItemToBoard(board.id, payload)) {
            showToast("Could not add to that collection.");
            return;
          }
          setPickerOpen(false);
          setActiveBoardId(board.id);
          activeBoardId = board.id;
          renderShelf();
          refreshHeartButtons();
          showToast("Added to " + board.name);
        });
        pickerList.appendChild(btn);
      });
    }

    function renderBoardTabs() {
      if (!boardTabs) return;
      boardTabs.textContent = "";
      getBoards().forEach(function (board) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "collections-board-tab";
        btn.setAttribute("aria-pressed", board.id === activeBoardId ? "true" : "false");
        btn.textContent = board.name;
        btn.addEventListener("click", function () {
          setActiveBoardId(board.id);
          activeBoardId = board.id;
          compareIds = {};
          setCompareOpen(false);
          renderShelf();
        });
        boardTabs.appendChild(btn);
      });
    }

    function updateSyncLabel() {
      if (!syncLabel) return;
      var base = collectorBase();
      if (!base) {
        syncLabel.textContent = "Saved on this device";
        return;
      }
      if (syncState === "syncing") syncLabel.textContent = "Syncing…";
      else if (syncState === "synced") {
        syncLabel.textContent = customerId()
          ? "Synced to your account"
          : "Synced on this device · sign in to keep across devices";
      } else if (syncState === "error") syncLabel.textContent = "Sync paused · changes stay on this device";
      else syncLabel.textContent = "Cloud sync ready";
    }

    document.addEventListener("theartfolio:collectionssync", updateSyncLabel);

    function renderBoardChrome(board) {
      if (boardTitle) boardTitle.textContent = board ? board.name : "Favourites";
      if (boardActions) {
        var isProject = board && board.kind === "project";
        if (renameBoardBtn) renameBoardBtn.hidden = !isProject;
        if (deleteBoardBtn) deleteBoardBtn.hidden = !isProject;
      }
      if (shareBoardBtn) {
        var hasItems = !!(board && (board.itemIds || []).length);
        shareBoardBtn.hidden = !(collectorBase() && hasItems);
      }
      updateSyncLabel();
    }

    function cardActionIcon(kind) {
      var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg.setAttribute("viewBox", "0 0 20 20");
      svg.setAttribute("width", "14");
      svg.setAttribute("height", "14");
      svg.setAttribute("aria-hidden", "true");
      svg.setAttribute("focusable", "false");
      svg.classList.add("favourite-card-action__icon");
      var paths = [];
      if (kind === "remix") {
        paths = [
          "M4.2 10a5.8 5.8 0 0 1 9.7-4.2M15.8 10a5.8 5.8 0 0 1-9.7 4.2",
          "M14.2 2.8v3.4h-3.4M5.8 17.2v-3.4h3.4"
        ];
      } else if (kind === "compare") {
        paths = [
          "M4 5.5h5.5V17H4zM10.5 5.5H16V17h-5.5z"
        ];
      } else if (kind === "compare-on") {
        paths = [
          "M4 5.5h5.5V17H4zM10.5 5.5H16V17h-5.5z",
          "M7.2 11.2l1.4 1.4 2.6-3.2"
        ];
      } else if (kind === "move") {
        paths = [
          "M4 10h9.5M10.5 6.5L14.5 10l-4 3.5",
          "M16 5.5v9"
        ];
      }
      paths.forEach(function (d) {
        var path = document.createElementNS("http://www.w3.org/2000/svg", "path");
        path.setAttribute("d", d);
        path.setAttribute("fill", "none");
        path.setAttribute("stroke", "currentColor");
        path.setAttribute("stroke-width", "1.5");
        path.setAttribute("stroke-linecap", "round");
        path.setAttribute("stroke-linejoin", "round");
        svg.appendChild(path);
      });
      return svg;
    }

    function renderShelf() {
      var store = readStore();
      if (!findBoard(store, activeBoardId)) {
        activeBoardId = getFavouritesBoard(store).id;
        setActiveBoardId(activeBoardId);
      }
      var board = findBoard(store, activeBoardId);
      var favourites = getBoardItems(store, activeBoardId);
      renderBoardTabs();
      renderBoardChrome(board);

      carousel.textContent = "";
      empty.hidden = favourites.length > 0;
      carousel.hidden = favourites.length === 0;
      if (empty) {
        empty.textContent = board && board.kind === "favourites"
          ? "No favourites yet. Tap Save on a look, or Add to collection."
          : "This collection is empty. Add looks from a product page.";
      }

      favourites.forEach(function (favourite) {
        var card = document.createElement("article");
        card.className = "favourite-card";
        if (compareIds[favourite.id]) card.classList.add("is-compare-selected");

        var link = document.createElement("a");
        link.className = "favourite-card-link";
        link.href = normaliseUrl(favourite.url);
        link.setAttribute(
          "aria-label",
          "Buy as shown: " + (favourite.title || "saved artwork") + ", " + (favourite.summary || "configured look")
        );

        var imageUrl = safeImageUrl(favourite.image);
        if (imageUrl) {
          var image = document.createElement("img");
          image.src = imageUrl;
          image.alt = "";
          image.loading = "lazy";
          link.appendChild(image);
        }

        var copy = document.createElement("span");
        copy.className = "favourite-card-copy";
        var title = document.createElement("strong");
        title.className = "favourite-card-title";
        title.textContent = favourite.title || "Untitled artwork";
        var summary = document.createElement("small");
        summary.className = "favourite-card-summary";
        summary.textContent = favourite.summary || "Configured look";
        copy.appendChild(title);
        copy.appendChild(summary);
        link.appendChild(copy);

        var actions = document.createElement("div");
        actions.className = "favourite-card-actions";

        var remix = document.createElement("a");
        remix.className = "favourite-card-action favourite-card-action--icon";
        remix.href = discoverRemixUrl(favourite);
        remix.title = "Remix";
        remix.setAttribute("aria-label", "Remix more like " + (favourite.title || "this look") + " in Discover");
        remix.appendChild(cardActionIcon("remix"));
        actions.appendChild(remix);

        var compare = document.createElement("button");
        compare.type = "button";
        compare.className = "favourite-card-action favourite-card-action--icon";
        var compareOn = !!compareIds[favourite.id];
        compare.setAttribute("aria-pressed", compareOn ? "true" : "false");
        compare.title = compareOn ? "Selected for compare" : "Compare";
        compare.setAttribute("aria-label", compareOn ? "Deselect from compare" : "Select for compare");
        compare.appendChild(cardActionIcon(compareOn ? "compare-on" : "compare"));
        compare.addEventListener("click", function () {
          if (compareIds[favourite.id]) {
            delete compareIds[favourite.id];
          } else {
            if (selectedCompare().length >= MAX_COMPARE) {
              showToast("Compare up to " + MAX_COMPARE + " looks");
              return;
            }
            compareIds[favourite.id] = true;
          }
          renderShelf();
        });
        actions.appendChild(compare);

        var move = document.createElement("button");
        move.type = "button";
        move.className = "favourite-card-action favourite-card-action--icon";
        move.title = "Move to another collection";
        move.setAttribute("aria-label", "Move " + (favourite.title || "this look") + " to another collection");
        move.appendChild(cardActionIcon("move"));
        move.addEventListener("click", function () {
          openPickerForLook(favourite, activeBoardId);
        });
        actions.appendChild(move);

        var remove = document.createElement("button");
        remove.type = "button";
        remove.className = "favourite-remove";
        remove.textContent = "×";
        remove.setAttribute("aria-label", "Remove " + (favourite.title || "this look") + " from collection");
        remove.addEventListener("click", function () {
          if (!removeItemFromBoard(activeBoardId, favourite.id)) {
            showToast("Collection could not be updated.");
            return;
          }
          renderShelf();
          refreshHeartButtons();
          showToast("Removed from collection");
        });

        card.appendChild(link);
        card.appendChild(actions);
        card.appendChild(remove);
        carousel.appendChild(card);
      });

      renderCount();
      updateCompareBar();
    }

    function setShelfOpen(open, opener) {
      window.clearTimeout(closeTimer);
      if (open) {
        lastOpener = opener || document.activeElement;
        measureShopifyAdminChrome();
        renderShelf();
        shelf.inert = false;
        shelf.removeAttribute("inert");
        shelf.setAttribute("aria-hidden", "false");
        backdrop.hidden = false;
        document.documentElement.classList.add("favourites-lock");
        openButtons.forEach(function (button) { button.setAttribute("aria-expanded", "true"); });
        window.requestAnimationFrame(function () {
          shelf.dataset.open = "true";
          closeButton.focus();
        });
        return;
      }

      delete shelf.dataset.open;
      shelf.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("favourites-lock");
      openButtons.forEach(function (button) { button.setAttribute("aria-expanded", "false"); });
      setCompareOpen(false);
      setPickerOpen(false);
      closeTimer = window.setTimeout(function () {
        shelf.inert = true;
        shelf.setAttribute("inert", "");
        backdrop.hidden = true;
      }, 320);
      if (lastOpener && document.contains(lastOpener)) lastOpener.focus();
      lastOpener = null;
    }

    function shelfIsOpen() {
      return shelf.dataset.open === "true";
    }

    function refreshHeartButtons() {
      document.querySelectorAll("[data-favourite-toggle]").forEach(function (button) {
        var look = currentLook(button);
        button.hidden = !look;
        if (!look) return;
        var saved = isFavourite(look.url);
        button.setAttribute("aria-pressed", saved ? "true" : "false");
        button.setAttribute("aria-label", saved ? "Remove this configured look from favourites" : "Save this configured look");
        var label = button.querySelector("[data-favourite-label]");
        var heart = button.querySelector(".favourite-heart");
        if (label) label.textContent = saved ? "Saved" : "Save";
        if (heart) heart.textContent = saved ? "♥" : "♡";
      });
    }

    function openPickerForLook(look, moveFromBoardId) {
      if (!picker || !pickerList) return;
      pickerLook = Object.assign({}, look);
      if (moveFromBoardId) pickerLook.__moveFrom = moveFromBoardId;
      else delete pickerLook.__moveFrom;
      picker.hidden = false;
      picker.setAttribute("aria-hidden", "false");
      pickerList.textContent = "";
      getBoards().forEach(function (board) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "collections-picker-item";
        btn.textContent = board.name + (board.kind === "favourites" ? " (default)" : "");
        btn.addEventListener("click", function () {
          if (!pickerLook) return;
          var fromId = pickerLook.__moveFrom;
          if (fromId && fromId !== board.id) {
            if (!moveItemToBoard(pickerLook.id, fromId, board.id)) {
              showToast("Could not move that look.");
              return;
            }
            showToast("Moved to " + board.name);
          } else {
            var payload = Object.assign({}, pickerLook, {
              id: makeId("look"),
              savedAt: nowIso()
            });
            delete payload.__moveFrom;
            if (!addItemToBoard(board.id, payload)) {
              showToast("Could not add to that collection.");
              return;
            }
            showToast("Added to " + board.name);
          }
          setPickerOpen(false);
          setActiveBoardId(board.id);
          activeBoardId = board.id;
          renderShelf();
          refreshHeartButtons();
        });
        pickerList.appendChild(btn);
      });
    }

    openButtons.forEach(function (button) {
      button.addEventListener("click", function () { setShelfOpen(true, button); });
    });
    closeButton.addEventListener("click", function () { setShelfOpen(false); });
    backdrop.addEventListener("click", function () { setShelfOpen(false); });
    if (compareOpen) {
      compareOpen.addEventListener("click", function () { setCompareOpen(true); });
    }
    if (compareClear) {
      compareClear.addEventListener("click", function () {
        compareIds = {};
        setCompareOpen(false);
        renderShelf();
      });
    }
    if (compareClose) {
      compareClose.addEventListener("click", function () { setCompareOpen(false); });
    }
    if (pickerClose) {
      pickerClose.addEventListener("click", function () { setPickerOpen(false); });
    }
    if (pickerNew) {
      pickerNew.addEventListener("click", function () {
        var name = window.prompt("Name this collection", "Project collection");
        if (name == null) return;
        var board = createBoard(name);
        if (!board) {
          showToast("Could not create collection.");
          return;
        }
        if (pickerLook) {
          var fromId = pickerLook.__moveFrom;
          if (fromId) {
            moveItemToBoard(pickerLook.id, fromId, board.id);
            showToast("Moved to " + board.name);
          } else {
            addItemToBoard(board.id, Object.assign({}, pickerLook, { id: makeId("look"), savedAt: nowIso() }));
            showToast("Added to " + board.name);
          }
        } else {
          showToast("Created " + board.name);
        }
        setPickerOpen(false);
        setActiveBoardId(board.id);
        activeBoardId = board.id;
        renderShelf();
        refreshHeartButtons();
      });
    }
    if (newBoardBtn) {
      newBoardBtn.addEventListener("click", function () {
        var name = window.prompt("Name this collection", "Project collection");
        if (name == null) return;
        var board = createBoard(name);
        if (!board) {
          showToast("Could not create collection.");
          return;
        }
        setActiveBoardId(board.id);
        activeBoardId = board.id;
        renderShelf();
        showToast("Created " + board.name);
      });
    }
    if (renameBoardBtn) {
      renameBoardBtn.addEventListener("click", function () {
        var board = findBoard(readStore(), activeBoardId);
        if (!board || board.kind === "favourites") return;
        var name = window.prompt("Rename collection", board.name);
        if (name == null) return;
        if (!renameBoard(board.id, name)) {
          showToast("Could not rename collection.");
          return;
        }
        renderShelf();
      });
    }
    if (deleteBoardBtn) {
      deleteBoardBtn.addEventListener("click", function () {
        var board = findBoard(readStore(), activeBoardId);
        if (!board || board.kind === "favourites") return;
        if (!window.confirm("Delete “" + board.name + "”? Looks only in this collection will be removed.")) return;
        if (!deleteBoard(board.id)) {
          showToast("Could not delete collection.");
          return;
        }
        activeBoardId = getActiveBoardId();
        renderShelf();
        showToast("Collection deleted");
      });
    }
    if (shareBoardBtn) {
      shareBoardBtn.addEventListener("click", function () {
        shareBoardBtn.disabled = true;
        createBoardShare(activeBoardId)
          .then(function (url) {
            if (navigator.clipboard && navigator.clipboard.writeText) {
              return navigator.clipboard.writeText(url).then(function () {
                showToast("Share link copied");
                return url;
              });
            }
            window.prompt("Copy this share link", url);
            showToast("Share link ready");
            return url;
          })
          .catch(function (error) {
            if (error && error.message === "empty_board") showToast("Add looks before sharing.");
            else if (error && error.message === "sync_unavailable") showToast("Cloud sharing is not configured yet.");
            else showToast("Could not create share link.");
          })
          .then(function () {
            shareBoardBtn.disabled = false;
          });
      });
    }

    document.addEventListener("click", function (event) {
      var collectBtn = event.target.closest("[data-favourite-collect]");
      if (collectBtn) {
        var collectLook = currentLook(collectBtn);
        if (!collectLook) return;
        if (!shelfIsOpen()) setShelfOpen(true, collectBtn);
        openPickerForLook(Object.assign({}, collectLook, {
          id: makeId("look"),
          productKey: productKeyFromUrl(collectLook.url),
          savedAt: nowIso()
        }));
        return;
      }

      var button = event.target.closest("[data-favourite-toggle]");
      if (!button) return;
      var look = currentLook(button);
      if (!look) return;
      var existing = findFavouriteForUrl(look.url);
      if (existing) {
        if (!removeFavourite(existing.id)) {
          showToast("Favourites could not be updated.");
          return;
        }
        showToast("Removed from favourites");
      } else {
        var favourite = Object.assign({}, look, {
          id: makeId("look"),
          productKey: productKeyFromUrl(look.url),
          savedAt: nowIso()
        });
        if (!addFavourite(favourite)) {
          showToast("This look could not be saved on this device.");
          return;
        }
        showToast("Saved to favourites");
      }
      renderShelf();
      refreshHeartButtons();
    });

    document.addEventListener("click", function (event) {
      if (event.target.closest("[data-pp-type], [data-view], [data-size-unit-value]")) {
        window.setTimeout(refreshHeartButtons, 0);
      }
    });
    document.addEventListener("change", function () {
      window.setTimeout(refreshHeartButtons, 0);
    });
    document.querySelectorAll("[data-discover]").forEach(function (discover) {
      discover.addEventListener("discover:pick", refreshHeartButtons);
    });
    window.addEventListener("storage", function (event) {
      if (event.key === COLLECTIONS_KEY || event.key === LEGACY_KEY) {
        activeBoardId = getActiveBoardId();
        renderShelf();
        refreshHeartButtons();
        document.dispatchEvent(new CustomEvent("theartfolio:favouriteschange"));
      }
    });
    document.addEventListener("keydown", function (event) {
      if (picker && !picker.hidden && event.key === "Escape") {
        event.preventDefault();
        setPickerOpen(false);
        return;
      }
      if (!shelfIsOpen()) return;
      if (event.key === "Escape") {
        event.preventDefault();
        if (comparePanel && !comparePanel.hidden) {
          setCompareOpen(false);
          return;
        }
        setShelfOpen(false);
        return;
      }
      if (event.key !== "Tab") return;
      var focusable = shelf.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    renderShelf();
    refreshHeartButtons();
    updateSyncLabel();
    if (collectorBase()) {
      pullCollectionsStore().then(function () {
        activeBoardId = getActiveBoardId();
        renderShelf();
        refreshHeartButtons();
        updateSyncLabel();
      });
    }
  });
})();
